import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { InviteFormContainer } from '@/components/pages/Membership/Invite/InviteForm';
import { pages } from '@/settings/pages';
import { Loading } from '@/components/utils/Loading';
import { useCheckAuthorizationFreshness } from '@/hooks/useCheckAuthorizationFreshness';

export const MembershipInvitePage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.membership.invite.title');
  const [isLoading, setIsLoading] = useState(true);

  const checkAuthorizationFreshness = useCheckAuthorizationFreshness(
    setIsLoading,
    pages.membership.invite,
  );

  useEffect(() => {
    checkAuthorizationFreshness();
  }, [checkAuthorizationFreshness]);

  return isLoading ? (
    <Loading />
  ) : (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      hasHeaderDivider={true}
      breadcrumbItems={[{ label: title }]}
      containerType="normal"
    >
      <InviteFormContainer />
    </PageRootWrapper>
  );
};
